import PropTypes from "prop-types";
import Icon from "../icon/Icon";

/**
 * Renders a student photo if available, or a placeholder icon.
 *
 * @param {string|null} props.src       - image URL from useStudentImages
 * @param {string}      props.firstName
 * @param {string}      props.lastName
 */
const StudentImage = ({ src, firstName, lastName }) =>
    src ? (
        <img
            src={src}
            alt={`${firstName} ${lastName}`}
            style={{ width: "75px", height: "100px", borderRadius: "5%", objectFit: "cover" }}
        />
    ) : (
        <Icon iconName="NO_STUDENT_IMAGE" fill="#19608F" height={100} width={75} />
    );

StudentImage.propTypes = {
    src: PropTypes.string,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired
};

StudentImage.defaultProps = {
    src: null
};

export default StudentImage;
